import staff1 from "../Images/Staffs/staff1.jpeg";
import staff2 from "../Images/Staffs/staff2.jpeg";
import staff3 from "../Images/Staffs/staff3.jpeg";
import staff4 from "../Images/Staffs/staff4.jpeg";
import staff5 from "../Images/Staffs/staff5.jpg";
import staff6 from "../Images/Staffs/staff6.jpg";
import staff7 from "../Images/Staffs/staff7.jpg";
import staff8 from "../Images/Staffs/staff8.jpg";
import staff9 from "../Images/Staffs/staff9.jpg";
import staff10 from "../Images/Staffs/staff10.jpg";

export const staffs = [
  {
    id: 1,
    name: "John Bot",
    job: "Manager",
    image: staff1,
  },
  {
    id: 2,
    name: "Katrine Kane",
    job: "Supervisor",
    image: staff10,
  },
  {
    id: 3,
    name: "Kade Krane",
    job: "Web Developer",
    image: staff3,
  },
  {
    id: 4,
    name: "Anna Lin",
    job: "Senior Hairstylist",
    image: staff4,
  },
  {
    id: 5,
    name: "Kate Jenner",
    job: "Senior Hairstylist",
    image: staff5,
  },
  {
    id: 6,
    name: "Alec Zander",
    job: "Senior Hairstylist",
    image: staff6,
  },
  {
    id: 7,
    name: "Maria Jone",
    job: "Senior Hairstylist",
    image: staff7,
  },
  {
    id: 8,
    name: "Jaden Stin",
    job: "Senior Hairstylist",
    image: staff8,
  },
  {
    id: 9,
    name: "Lina Kay",
    job: "Senior Hairstylist",
    image: staff9,
  },
  {
    id: 10,
    name: "Kim Lin",
    job: "Product Manager",
    image: staff2,
  },
];
